import { Component, OnInit, Input } from '@angular/core';
import { Destinations } from '@app/models';
import {environment} from "@env/environment";
/**
 * Componente que muestra una imagen con diferentes formas y tamaños.
 * Este componente permite cargar imágenes desde un CMS o desde recursos locales.
 */
type Shape = "circle" | "square" | "squarerd";
type SizeImage = "sm" | "md" | "mdx" | "lg"
@Component({
    selector: 'app-am-image',
    templateUrl: './am-image.component.html',
    styleUrls: ['./am-image.component.scss'],
    standalone: false
})
export class AmImageComponent implements OnInit {
/**
   * Indica si la imagen debe tener una animación.
   *
   * @type {boolean}
   * @default false
   */
@Input() animated: boolean = false;

/**
 * Indica si la imagen es en blanco y negro.
 *
 * @type {boolean}
 * @default false
 */
@Input() isBN: boolean = false;

/**
 * Nombre de la imagen (código de la ciudad).
 *
 * @type {string}
 * @default ''
 */
@Input() name: string = '';

/**
 * Forma de la imagen (círculo, cuadrado, etc.).
 *
 * @type {Shape}
 * @default 'circle'
 */
@Input() shape: Shape = 'circle';

/**
 * Tamaño de la imagen (pequeño, mediano, grande, etc.).
 *
 * @type {SizeImage}
 * @default 'lg'
 */
@Input() size: SizeImage = 'lg';

/**
 * Clase CSS aplicada a la imagen.
 *
 * @type {string}
 */
classImg = '';

/**
 * Indica si la imagen se carga desde el CMS.
 *
 * @type {boolean}
 */
hasCms = false;

/**
 * Indica si la imagen se carga desde recursos locales.
 *
 * @type {boolean}
 */
hasLocal = false;

/**
 * URL de la imagen cargada desde recursos locales.
 *
 * @type {string}
 */
url = '';

/**
 * URL de la imagen cargada desde el CMS.
 *
 * @type {string}
 */
urlCMS = '';

/**
 * URL de la imagen predeterminada en caso de error.
 *
 * @type {string}
 */
urlDefault = '';


  constructor() { }

  ngOnInit(): void {
    if (this.name) {
    let image = this.validateCMSImage(this.name);
    if(image) {
      this.urlCMS = image;
      this.hasCms = true;
    }
    else {
        this.hasCms = false;
        this.hasLocal = true

      }

      this.url = 'assets/images/lugares/'+ this.name+'_large.png';
      this.urlDefault = 'assets/images/lugares/default.jpg';
      this.hasCms = true;
    } else {
      this.urlDefault = 'assets/images/lugares/default.jpg';
      this.hasCms = false;
      this.hasLocal = false;
    }
  }
 /**
   * Método que se ejecuta cuando ocurre un error al cargar la imagen desde el CMS.
   * Cambia el estado de `hasCms` a `false` y activa la carga de la imagen local.
   *
   * @param {any} event - Evento de error.
   * @return {void} No retorna ningún valor.
   */
  onErrorCMS(event) {
    this.hasCms = false;
    this.hasLocal = true
  }
   /**
   * Método que se ejecuta cuando ocurre un error al cargar la imagen desde recursos locales.
   * Cambia el estado de `hasLocal` y `hasCms` a `false`.
   *
   * @param {any} event - Evento de error.
   * @return {void} No retorna ningún valor.
   */
  onErrorLocal(event) {
    this.hasLocal = false
    this.hasCms = false;
  }
 /**
   * Método que valida si la imagen existe en el CMS.
   * Si existe, devuelve la URL completa de la imagen en el CMS.
   *
   * @param {string} cityCode - Código de la ciudad para buscar la imagen.
   * @return {string | null} URL de la imagen en el CMS o `null` si no existe.
   */
  validateCMSImage(cityCode: string): string {
    let ulrImage = null;
    const imgResp = Destinations.findDestination(cityCode);
    let imageCMS = null;
    if(imgResp) {
      imageCMS = imgResp?.imgUrl;
    }
    if (imageCMS && imageCMS.length > 0) {
      imageCMS = imageCMS.replace("/cms/", '')
      ulrImage = `${environment.cmsUrl}/${imageCMS}`;
    }
    return ulrImage

  }

}
